import { useState, useCallback } from 'react';
import { ToastVariant } from '../components/ui/toast';

interface ToastItem {
  id: string;
  title: string;
  description?: string;
  variant?: ToastVariant;
  duration?: number;
}

let toastQueue: ToastItem[] = [];
let listeners: Array<(toasts: ToastItem[]) => void> = [];

const notify = () => {
  listeners.forEach(fn => fn([...toastQueue]));
};

export const toast = {
  success: (title: string, description?: string) => {
    const id = Date.now().toString();
    toastQueue = [...toastQueue, { id, title, description, variant: 'success', duration: 4000 }];
    notify();
    setTimeout(() => {
      toastQueue = toastQueue.filter(t => t.id !== id);
      notify();
    }, 4000);
  },
  error: (title: string, description?: string) => {
    const id = Date.now().toString();
    toastQueue = [...toastQueue, { id, title, description, variant: 'destructive', duration: 5000 }];
    notify();
    setTimeout(() => {
      toastQueue = toastQueue.filter(t => t.id !== id);
      notify();
    }, 5000);
  },
  info: (title: string, description?: string) => {
    const id = Date.now().toString();
    toastQueue = [...toastQueue, { id, title, description, variant: 'info', duration: 4000 }];
    notify();
    setTimeout(() => {
      toastQueue = toastQueue.filter(t => t.id !== id);
      notify();
    }, 4000);
  },
};

export const useToastState = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const subscribe = useCallback(() => {
    const listener = (newToasts: ToastItem[]) => setToasts(newToasts);
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  }, []);

  return { toasts, subscribe };
};

export default toast;
